import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { array, object, string } from 'yup';
import { GoalsFormValues } from 'src/models/Goal.model';
import GoalForm from '../Layout/GoalForm';
import { useEditGoalsMutation, useGetGoalsByIdQuery } from 'src/services/GoalServices';
import { showToast } from 'src/utils/showToaster';
import moment from 'moment';
import { CircularProgress } from '@mui/material';

type Props = {
  onClose: () => void;
  goalId: string;
};

const EditGoalFormWrapper = ({ onClose, goalId }: Props) => {
  const [editGoal] = useEditGoalsMutation();
  const [goal, setGoal] = useState<any>({})
  const { data, isLoading, isFetching } = useGetGoalsByIdQuery(goalId)

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setGoal(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: GoalsFormValues = {
    goalCategoryId: {
      label: goal?.goalCategoryName,
      value: goal?.goalCategoryId
    },
    deadline: goal?.deadline,
    type: goal?.type,
    name: goal?.name || '',
    target: goal?.target,
    members: goal?.membersInvolved?.map((ele: any) => {
      return {
        label: ele?.memberName,
        value: ele?.memberId,
      };
    }),
    measuredBy: {
      label: goal?.measuredByName,
      value: goal?.measuredById
    },

  };
  // Validation Schema
  const validationSchema = object().shape({
    deadline: string().required("Please enter deadline date"),
    name: string().required("Please enter name"),
    type: string().required("Please select type"),
    goalCategoryId: object().required("Please select goal category"),
    measuredBy: object().required("Please select measured"),
    members: array()
      .min(1, "Please select member")
      .required("Please select member"),

  });
  // Handle Submit
  const handleSubmit = (
    values: GoalsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<GoalsFormValues>
  ) => {
    const formattedValues = {
      goalCategoryId: values?.goalCategoryId?.value,
      deadline: values?.deadline ? moment(values?.deadline).format('YYYY-MM-DD') : '',
      type: values?.type,
      name: values?.name,
      target: values?.target,
      measuredById: values?.measuredBy?.value,
      membersInvolved: values?.members?.map((ele: any) => ele?.value),
    };
    editGoal({
      body: formattedValues,
      goalId: goalId
    }).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setSubmitting(false);
    })
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}

            <GoalForm formikProps={formikProps} onClose={onClose} formType={'Edit'} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditGoalFormWrapper;